import jsPDF from 'jspdf';
import { PDF_COLORS } from '../../config/colors';
import { PDF_FONTS, PDF_LAYOUT } from '../../config/fonts';
import { PageManager } from '../../helpers/pageBreaks';

export class SectionHeaderComponent {
  private pdf: jsPDF;
  private pageManager: PageManager;

  constructor(pdf: jsPDF, pageManager: PageManager) {
    this.pdf = pdf;
    this.pageManager = pageManager;
  }

  render(): void {
    this.pageManager.checkForPageBreak(60, {
      minSpaceAfter: 40,
      elementType: 'recommendations-section-header',
    });

    // Main section title
    this.pdf.setFont(PDF_FONTS.primary, 'bold');
    this.pdf.setFontSize(PDF_FONTS.size.heading);
    this.pdf.setTextColor(...PDF_COLORS.primary);
    this.pdf.text(
      'Recommendations & Action Plan',
      PDF_LAYOUT.margins.left,
      this.pageManager.getCurrentY()
    );

    this.pageManager.addElement(PDF_FONTS.size.heading, {
      spacingAfter: PDF_LAYOUT.spacing.paragraph,
      elementType: 'section-header',
    });

    // Section description
    this.pdf.setFont(PDF_FONTS.primary, 'normal');
    this.pdf.setFontSize(PDF_FONTS.size.body);
    this.pdf.setTextColor(...PDF_COLORS.text.secondary);

    const description = this.pdf.splitTextToSize(
      'Based on your assessment results, this section provides targeted recommendations to improve your export readiness. Focus on the priority areas identified below to maximize your chances of export success.',
      this.pageManager.getContentWidth()
    );

    const descriptionHeight = description.length * PDF_FONTS.size.body * 1.2;
    this.pageManager.checkForPageBreak(descriptionHeight + 25, {
      minSpaceAfter: 20,
    });

    description.forEach((line: string) => {
      this.pdf.text(line, PDF_LAYOUT.margins.left, this.pageManager.getCurrentY());
      this.pageManager.addLine();
    });

    this.pageManager.addSection();
  }
}